import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { of } from 'rxjs';
import {
  FormBuilder,
  FormGroup,//Collections of FormControl
  FormArray,//Array of FormControls
  FormControl,// Individual form Item, maintain status and validation rules
  ValidatorFn
} from '@angular/forms';
//https://coryrylan.com/blog/creating-a-dynamic-checkbox-list-in-angular
//https://medium.com/@vladguleaev/reusable-angular-create-multiple-checkbox-group-component-84f0e4727677

//https://netbasal.com/handling-multiple-checkboxes-in-angular-forms-57eb8e846d21
import * as _ from "lodash";

import { ResultsService } from '../../services/master/results/results.service';

@Component({
  selector: 'app-sub-results-selection',
  templateUrl: './sub-results-selection.component.html',
  styleUrls: ['./sub-results-selection.component.scss']
})

export class SubResultsSelectionComponent implements OnChanges {
  form: FormGroup;
  selectionList = [];
  netTestData = [
    { id: 1, name: 'TCP' },
    { id: 2, name: 'UDP' },
    { id: 3, name: 'VOIP' },
    { id: 4, name: 'ROUTE' },
    { id: 5, name: 'HTTP' },
    { id: 6, name: 'FTP' },
    { id: 7, name: 'DNS' },
    { id: 8, name: 'SMS' },
    { id: 9, name: 'EMAIL' }
  ];

  mobileInfoData = [
    { id: 1, name: 'Phone' },
    { id: 2, name: 'SIM' },
    { id: 3, name: 'UE' }
  ];

  constructor(private resultsService: ResultsService) {//(private formBuilder: FormBuilder) {
    //this.form = this.formBuilder.group({
    //  results: new FormArray([], this.minSelectedCheckboxes(1))
    //});

    //// async results (could be a http service call)
    //of(this.getOrders()).subscribe(results => {
    //  this.selectionList = results;
    //  this.addCheckboxes();
    //});

    ////// synchronous results
    ////this.selectionList = this.getOrders();
    ////this.addCheckboxes();

    this.resultsService.NetTestOrMobInfo.subscribe(res => {
      //this.RsltTypeSwitch = res.RsltTypeSwitch;


      if (res.RsltTypeSwitch === true) {
        this.netTests.forEach(function (value, i) {
          value.selected = false;
          res.selectedNetTestIndex.forEach(function (indexSelected) {
            if (i === indexSelected)
              value.selected = true;
          });
        });
      }
      else {
        this.mobileInfos.forEach(function (value, i) {
          value.selected = false;
          res.selectedMobInfoIndex.forEach(function (indexSelected) {
            if (i === indexSelected)
              value.selected = true;
          });
        });
      }

    });
  }

  //private addCheckboxes() {
  //  this.selectionList.forEach((o, i) => {
  //    const control = new FormControl(i < this.selectionList.length);//select all options by default   (i === 0); // if first item then set it to true, else false
  //    (this.form.controls.results as FormArray).push(control);
  //  });
  //}

  //getOrders() {
  //  return this.netTestData;
  //}

  minSelectedCheckboxes(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        // get a list of checkbox values (boolean)
        .map(control => control.value)
        // total up the number of checked checkboxes
        .reduce((prev, next) => next ? prev + next : prev, 0);

      // if the total is not greater than the minimum, return the error message
      return totalSelected >= min ? null : { required: true };
    };

    return validator;
  }

  //submit() {
  //  const selectedOrderIds = this.form.value.results
  //    .map((v, i) => (v ? this.selectionList[i].id : null))2226
  //    .filter(v => v !== null);
  //  console.log(selectedOrderIds);
  //}



  //https://medium.com/@DheerajJaiswal6/multi-checkbox-form-control-angular7-39cbdabede57
  @Input() RsltTypeSwitch: boolean;
  @Output() childSubRsltsEvent = new EventEmitter<any>();

  subResultsForm: FormGroup;
  //selectedResultsNames: [string];
  netTests: any = [
    {
      name: "TCP",
      value: "TCPDATA",
      selected: true
    },
    {
      name: "UDP",
      value: "UDPDATA",
      selected: true
    },
    {
      name: "VOIP",
      value: "VOIPDATA",
      selected: true
    },
    {
      name: "ROUTE",
      value: "ROUTEDATA",
      selected: true
    },
    {
      name: "HTTP",
      value: "HTTPDATA",
      selected: true
    },
    {
      name: "FTP",
      value: "FTPDATA",
      selected: true
    },
    {
      name: "DNS",
      value: "DNSDATA",
      selected: true
    },
    {
      name: "SMS",
      value: "SMSDATA",
      selected: true
    },
    {
      name: "EMAIL",
      value: "EMAILDATA",
      selected: true
    }
  ];
  mobileInfos: any = [
    {
      name: "Phone",
      value: "GENERALINFO",
      selected: true
    },
    {
      name: "SIM",
      value: "SIMINFO",
      selected: true
    },
    {
      name: "UE",
      value: "UEINFO",
      selected: true
    }
  ];

  ngOnChanges(changes: SimpleChanges): void {
    this.createFormInputs();
  }

  //used in HTML - IMP
  get rslts() {
    return this.subResultsForm.get('rslts') as FormArray;
  }
  createFormInputs() {
    this.subResultsForm = new FormGroup({
      rslts: this.createResults(this.RsltTypeSwitch === true ? this.netTests : this.mobileInfos)
    });
    this.childSubmit();
    //this.getSelectedResults();
  }

  createResults(rsltsInputs) {
    const arr = rsltsInputs.map(rslt => {
      return new FormControl(rslt.selected || false);
    });
    return new FormArray(arr, this.minSelectedCheckboxes(1));
  }

  //getSelectedResults() {
  //  this.selectedResultsNames = _.map(
  //    this.subResultsForm.controls.rslts["controls"],
  //    (rslt, i) => {
  //      return rslt.value && this.netTests[i].value;
  //    }
  //  );
  //  this.getSelectedResultsName();
  //}

  //getSelectedResultsName() {
  //  this.selectedResultsNames = _.filter(
  //    this.selectedResultsNames,
  //    function (rslt) {
  //      if (rslt !== false) {
  //        return rslt;
  //      }
  //    }
  //  );
  //}

  childSubmit() {

    const selectedSubResultsIndex = this.subResultsForm.value.rslts
      .map((v, i) => (v ? i : null))
      .filter(v => v !== null);

    //console.log(selectedSubResultsIndex)//To be passed as selected rslt types indices to API

    //https://stackoverflow.com/questions/47821809/rangeerror-maximum-call-stack-size-exceeded-when-using-valuechanges-subscribe - dont call subject next set inside subscribe - iMP
    let newRes:any;
    this.resultsService.NetTestOrMobInfo.subscribe(res => newRes = res);
    if (newRes !== undefined) {
      this.resultsService.setNetTestOrMobInfo({
        RsltTypeSwitch: this.RsltTypeSwitch,
        selectedNetTestIndex: this.RsltTypeSwitch === true ? selectedSubResultsIndex : newRes.selectedNetTestIndex,
        selectedMobInfoIndex: this.RsltTypeSwitch === false ? selectedSubResultsIndex : newRes.selectedMobInfoIndex
      });
    }


    const selectedSubResults = this.subResultsForm.value.rslts
      .map((v, i) => (v ? (this.RsltTypeSwitch === true ? this.netTests[i].value : this.mobileInfos[i].value) : null))
      .filter(v => v !== null);

    this.childSubRsltsEvent.emit(selectedSubResults);
  }
}
